import { Table } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { GeneralCallFragment } from "__generated__/view/calls/graphql/call.fragments.generated";
import { VoyageLink } from "utils/LinkUtils";

type LinkedPushedBargeCall =
	Pick<GeneralCallFragment, "id" | "weight"> & {
	voyage?: Pick<GeneralCallFragment["voyage"], "id" | "voyageNumber"> & { ship: Pick<GeneralCallFragment["voyage"]["ship"], "id" | "name"> } | null;
}

const LinkedPushedBargeCallsTable = ({ linkedCalls }: { linkedCalls: LinkedPushedBargeCall[] } ) => {
	return (
		<Table
			content={[ ...linkedCalls ]}
			id={"linkedPushedBargeCallsTable"}
			columns={[ {
				id: "ship",
				title: intl.formatMessage({ id: "SHIP" }),
				render: (row: LinkedPushedBargeCall) => row.voyage?.ship?.name,

			}, {
				id: "voyage",
				title: intl.formatMessage({ id: "VOYAGES_VOYAGE_NUMBER" }),
				render: (row: LinkedPushedBargeCall) => <VoyageLink voyage={row.voyage} />,
			}, {
				id: "weight",
				title: intl.formatMessage({ id: "WEIGHT" }),
			},
			]}
		/>
	);
};

export default LinkedPushedBargeCallsTable;
